<template>
	<div class="product-wrap">
		<!-- <Header :logoTitle="logoTitle"/> -->
		<!-- <div id="nav-top">
			<navTop></navTop>
		</div> -->
		<div :class="[$route.meta.isFull?'':'container']">
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
	import Header from '@/components/product/header'
	import navTop from '@/components/product/navTop'
	import homeModule from '@/modules/product/home.js'
	export default {
		name: 'product',
		components: {
			Header,
			navTop
		},
		data() {
			return {
				activeIndex: 1,
				logoTitle: ''
			}
		},
		mixins: [
			homeModule
		],
		created(){
			this.getConfigData()
		},
		methods: {
		}
	}
</script>
<style scoped lang="less">
	.product-wrap{
		// margin-top: -30px;
		// position: relative;
		// z-index: 9999;
		padding-top: 60px;
	}
	.container{
		width: 1180px;
		margin: 0 auto;
	}
</style>
